module.exports = __webpack_public_path__ + "img/directivo-2.b664210e.jpg";